export const SUPPORTED_LOCALES = ["es", "en", "zh"];

export const DEFAULT_LOCALE = "es";

export const LOCALE_LABELS = {
  es: "ES",
  en: "EN",
  zh: "中文",
};

export const LOCALE_STORAGE_KEY = "caomei_locale";

export const isSupportedLocale = (locale) =>
  SUPPORTED_LOCALES.includes(locale);

export const getPreferredLocale = () => {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && isSupportedLocale(stored)) {
      return stored;
    }
  } catch {
    // ignore storage errors
  }
  return DEFAULT_LOCALE;
};

export const persistLocale = (locale) => {
  if (!isSupportedLocale(locale)) {
    return;
  }
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore storage errors
  }
};

/** Strip leading locale segment from a pathname. */
export const stripLocaleFromPath = (pathname = "") => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length && isSupportedLocale(parts[0])) {
    const rest = parts.slice(1).join("/");
    return rest ? `/${rest}` : "/";
  }
  return pathname.startsWith("/") ? pathname : `/${pathname}`;
};

/** Prefix a locale-free path with a locale. Absolute URLs are unchanged. */
export const withLocale = (path, locale = DEFAULT_LOCALE) => {
  if (!path) {
    return `/${locale}`;
  }
  if (/^(https?:|mailto:|tel:)/i.test(path)) {
    return path;
  }

  const hashIndex = path.indexOf("#");
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : "";
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const searchIndex = withoutHash.indexOf("?");
  const search = searchIndex >= 0 ? withoutHash.slice(searchIndex) : "";
  const pathname = searchIndex >= 0 ? withoutHash.slice(0, searchIndex) : withoutHash;

  const clean = stripLocaleFromPath(pathname);
  const localized =
    clean === "/"
      ? `/${locale}`
      : `/${locale}${clean.startsWith("/") ? clean : `/${clean}`}`;
  return `${localized}${search}${hash}`;
};

/** Swap locale prefix while preserving the rest of the path (and search/hash). */
export const swapLocaleInPath = (pathname, nextLocale) => {
  const withoutLocale = stripLocaleFromPath(pathname);
  return withLocale(withoutLocale, nextLocale);
};
